@for(meta of metadata?.columns; track meta; let index=$index)
{
    <div [style.width]="meta?.width"
         [ngClass]="options.cssClasses.headerCellDiv | mergeCssClasses: [meta?.headerClass]"
         [orderable]="!!meta?.ordering"
         [orderById]="meta?.id">
        @if(meta?.titleVisible)
        {
            @if(meta?.headerTemplate)
            {
                <ng-template *ngTemplateOutlet="meta?.headerTemplate ?? null; context: meta | cellContext: index"/>
            }
            @else 
            {
                <span [ngClass]="options.cssClasses.spanContent">{{meta?.title}}</span>
            }
        }
    </div>
}
